import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientCompaniesAvailableToAllocateInBranchSummaryProps<T> = {
  companyId?: string
  filters?: {
    search?: string
    page?: number
    productCategoryId?: string
  }
  mapper?: (data: any) => T
}

export const useClientCompaniesAvailableToAllocateInBranchesSummary = <T,>({
  companyId,
  filters: { search = '', page, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseClientCompaniesAvailableToAllocateInBranchSummaryProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientCompaniesAvailableToAllocateInBranchesSummary', companyId, search, page, productCategoryId],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${companyId}/available_to_allocate_in_branches_summary`, {
        params: {
          search,
          page,
          product_category_id: productCategoryId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
